// url 查询参数转对象
import { WxQkeyArr } from '@/typeAll';

// 解析url 的所有参数
export function getUrlAll(url = '') {
    const allObj = {
        qObj: {},
        host: '',
        hashArr: [],
    };

    if (typeof url !== 'string') {
        console.error(`url 不为字符串 ${url}`);
        return allObj;
    }

    if (!url.startsWith('http')) {
        console.warn(`url 不为网络地址 ${url}`);
        return allObj;
    }

    let spItemArr = [];
    spItemArr = url.split('#');
    spItemArr = spItemArr.map((item, index) => {
        if (index !== 0) {
            return `#${item}`;
        }
        return item;
    });

    const useArr = [];
    spItemArr.forEach((item) => {
        // console.log(item);
        const useArrItem = item.split('?');
        useArr.push(...useArrItem);
    });

    const hashArr = [];
    useArr.forEach((item, index) => {
        if (index !== 0) {
            if (item.startsWith('#')) {
                // hash
                hashArr.push(item);
            } else {
                // 查询参数
                const qArr = item.split('&');
                if (qArr) {
                    for (let i = 0; i < qArr.length; i++) {
                        const kvStr = qArr[i];
                        const kvStrArr = kvStr.split('=');
                        const key = kvStrArr[0];
                        const value = kvStrArr[1];
                        if (typeof value === 'string') {
                            allObj.qObj[decodeURIComponent(key)] = decodeURIComponent(value);
                        }
                    }
                }
            }
        } else {
            allObj.host = item;
        }
    });

    allObj.hashArr = hashArr;
    return allObj;

    // console.log(useArr);
}

export function parseQueryParams(url) {
    return getUrlAll(url).qObj;

    // return params;
}

// 对象转为查询字符串
export function objectToQueryParams(obj, addQst = false) {
    const queryParams = [];
    let targetStr = '';
    if (!obj) {
        return '';
    }

    Object.keys(obj).forEach((key) => {
        // const v = obj[key];
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(obj[key]);
        queryParams.push(`${encodedKey}=${encodedValue}`);
    });
    targetStr = queryParams.join('&');
    if (targetStr && addQst) {
        targetStr = `?${targetStr}`;
    }
    return targetStr;
}

// 给定一个url, 返回一个删除查询参数后的url
export function getDelQUrl(url) {
    const arrObj = getUrlAll(url);
    return arrObj.host + (arrObj.hashArr[0] || '');
}

// 给一个url, 去除查询参数指定的key
export function getDelQKeyUrl(url, delKeyArr = WxQkeyArr, addKVObj = {}) {
    if (!url || !delKeyArr) return url;
    const delUrl = getDelQUrl(url);
    const qObj = parseQueryParams(url);

    delKeyArr.forEach((key) => {
        delete qObj[key];
    });
    if (addKVObj) {
        Object.keys(addKVObj).forEach((key) => {
            const v = addKVObj[key];
            qObj[key] = v;
        });
    }
    return delUrl + objectToQueryParams(qObj, true);
}

// 获取微信js sdk init 的地址
export function getWxSDKSignatureUrl(url) {
    const useUrl = url || location.href;
    return useUrl.split('#')[0];
}
